// extracted by mini-css-extract-plugin
module.exports = {"md":"bonus-badge_md_TDrxS","ios":"bonus-badge_ios_3uBhZ","badge":"bonus-badge_badge_ljihh","label":"bonus-badge_label_nidKL"};